module.exports = __webpack_public_path__ + "static/media/Brands partner Infographic Desktop - GBR network - 07-06-2024 C.c9d0651d.gif";